<template>
  <div>
    <div id="container" class="library_st_detail grid-container">
      <Sidebar />
      <Subbar class="sub_bar_custom" />

      <!-- 도서 기본 정보 START -->
      <div
        v-if="!isBookshelfBookLoading && getBookshelfCurrentBook"
        class="section full relative"
      >
        <div class="inner">
          <div class="detail_book">
            <div class="eplist">
              <div>
                <div class="cover_wrap">
                  <div class="thum_wrap">
                    <div
                      v-show="purchaseLabel"
                      :class="[
                        purchaseLabel === '소장'
                          ? 'free_label_2'
                          : purchaseLabel === '증정본'
                          ? 'free_label_3'
                          : ''
                      ]"
                      class="free_label"
                    >
                      {{ purchaseLabel }}
                    </div>

                    <!-- <img
                      :src="getBookshelfCurrentBook.thumbUrl"
                      :alt="getBookshelfCurrentBook.title"
                      :style="isEndView ? 'opacity:0.3' : 'opacity:1'"
                    /> -->
                    <img
                      :src="getBookshelfCurrentBook.thumbUrl"
                      :alt="getBookshelfCurrentBook.title"
                    />
                  </div>
                </div>
                <div
                  v-if="getBookshelfCurrentBook.webViewerYn === 'Y'"
                  class="preview_btn_wrap"
                >
                  <a
                    v-if="
                      getBookshelfCurrentBook.ebookOrders &&
                      !getBookshelfCurrentBook.ebookOrders.isViewable
                    "
                    href="#"
                    class="an_a buy_btn"
                    @click="goToCart"
                    ><span class="an_t">바로 구매</span></a
                  >
                  <a v-else href="#" class="an_a" @click="showInViewer">
                    <span class="an_t">바로 보기</span>
                  </a>
                </div>
                <div
                  v-if="getSupplementExists"
                  ref="supplementWrap"
                  class="supplement_wrap"
                >
                  <div
                    class="supplement_download"
                    @click="showSuppleList = !showSuppleList"
                  >
                    <img
                      src="@/assets/images/nav/supple_arrow.png"
                      alt="화살표"
                      :class="{ 'is-open': showSuppleList }"
                    />
                    <span>부록 다운로드</span>
                  </div>
                  <ul v-show="showSuppleList" class="supplement_list">
                    <li
                      v-for="(supplement, index) in processedSource"
                      :key="index"
                    >
                      <div
                        class="download_btn"
                        @click="downloadTry(supplement)"
                      >
                        <img
                          src="@/assets/images/nav/supple_download.png"
                          alt="부록 다운로드"
                        />
                        <img
                          :src="supplement.icon"
                          :alt="supplement.typeText"
                        />
                        <span class="supple_name">{{
                          supplement.fileName
                        }}</span>
                        <span class="supple_size">{{
                          toNumInUnits(supplement.fileSize)
                        }}</span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div>
                <div class="info_wrap">
                  <div class="row">
                    <p class="iconbox">
                      <!-- <span
                        :class="{
                          active: getBookshelfCurrentBook.buyTp.paperbook
                        }"
                        class="meta_editer book"
                      >
                        <span class="an_i" />
                        <span class="an_t">{{
                          $t('views.library.librarybookdetail.book')
                        }}</span>
                      </span> -->
                      <span
                        :class="{ active: getBookshelfCurrentBook.buyTp.ebook }"
                        class="meta_editer epub ebook"
                      >
                        e-Book
                      </span>
                      <span
                        v-if="getSupplementExists"
                        class="meta_editer epub supplement"
                      >
                        부록 포함
                      </span>
                      <!-- <span
                        :class="{ active: getBookshelfCurrentBook.buyTp.pod }"
                        class="meta_editer pod"
                      >
                        <span class="an_i" />
                        <span class="an_t">{{
                          $t('views.library.librarybookdetail.pod')
                        }}</span>
                      </span> -->
                    </p>

                    <h3 class="meta_title">
                      {{ getBookshelfCurrentBook.title }}
                    </h3>
                    <p class="meta_author">
                      <span class="sub">저자: </span>
                      {{ getBookshelfCurrentBook.author }}
                    </p>
                    <p class="meta_publisher">
                      <span class="sub">출판사: </span>
                      {{ getBookshelfCurrentBook.publisher }}
                    </p>
                    <p class="meta_date">
                      <span class="sub">종이책 출판일: </span>
                      {{ getBookshelfCurrentBook.publishDate || date }}
                    </p>
                    <p class="meta_ebook_date">
                      <span class="sub">전자책 출판일: </span
                      >{{ getBookshelfCurrentBook.epublishDate }}
                    </p>
                    <p v-if="getSupplementExists" class="meta_supplement">
                      <span class="sub">보조자료: </span>
                      <span v-if="getSupplementFileNames.length === 1">
                        {{ getSupplementFileNames[0] }}
                      </span>
                      <span v-else>
                        {{ getSupplementFileNames[0] }} 외
                        {{ getSupplementFileNames.length - 1 }} 건
                      </span>
                    </p>
                    <!-- <div class="meta_rate">
                      <span class="score_wrap">
                        <StarRating
                          class="star_rating"
                          :rating="getBookshelfCurrentBook.rate.average"
                          active-color="#FFC515"
                          :star-size="starSize"
                          :increment="increment"
                          :show-rating="showRating"
                          :read-only="readOnly"
                        />

                        <span class="score_score">{{
                          getBookshelfCurrentBook.rate.average.toFixed(2)
                        }}</span>
                        <span class="blind">{{ $t('common.ui.rating') }}</span>
                        <span class="score_count_w">
                          <span class="score_count"
                            >({{
                              getBookshelfCurrentBook.rate.rateCount
                            }})</span
                          >
                          <span class="blind">{{
                            $t('common.ui.people')
                          }}</span>
                        </span>
                      </span>
                    </div> -->
                    <div style="width: 100%;"></div>
                    <div class="meta_detail">
                      <dl>
                        <dt style="text-align: left;">
                          이북 이용 기간
                        </dt>
                        <dd>
                          <div class="flex">
                            {{ getBookshelfCurrentBook.ebookOrders.rightsFrom }}
                            ~
                            {{
                              getBookshelfCurrentBook.ebookOrders.rightsTo ||
                              '무제한'
                            }}
                            <span class="right_days">
                              {{ getRightDays }}
                            </span>
                          </div>
                        </dd>
                        <dt style="text-align: left;">
                          {{ $t('views.library.librarybookdetail.1259') }}
                        </dt>
                        <dd>
                          {{
                            getBookshelfCurrentBook.rmsData.lastViewDate | date
                          }}
                        </dd>
                        <dt style="text-align: left;">
                          {{ $t('views.library.librarybookdetail.proc') }}
                        </dt>
                        <dd>
                          {{ getBookshelfCurrentBook.rmsData.readRate }}
                          %
                        </dd>
                      </dl>
                    </div>
                  </div>
                </div>

                <!-- <div class="btn_wrap">
                  <div class="bdsi_f2">
                    
                    <a href="javascript:void(0)" class="box_btn"
                      ><span class="an_t">{{ $t('views.library.librarybookdetail.6373') }}</span></a
                    >
                    
                  </div>
                  <div class="bdsi_f2">
                    <router-link
                      v-if="getBookshelfCurrentBook.podYn === 'Y'"
                      :to="{
                        name: 'book_detail',
                        params: { id: getBookshelfCurrentBook.bookCd }
                      }"
                      class="box_btn"
                      ><span class="an_t">{{
                        $t('views.library.librarybookdetail.pod1')
                      }}</span></router-link
                    >
                    <a
                      v-else
                      class="box_btn"
                      @click="
                        toggleErrorModal(
                          'POD 인쇄를 위한 템플릿 옵션을 준비 중입니다.'
                        )
                      "
                    >
                      <span class="an_t">{{
                        $t('views.library.librarybookdetail.pod2')
                      }}</span>
                    </a>
                  </div>
                  <div class="qtxt_btn">
                    <button class="btn_open_msg" @click="togglePodModal">
                      <span class="tt">{{
                        $t('views.library.librarybookdetail.pod3')
                      }}</span
                      ><span class="svg_q">?</span>
                    </button>
                  </div>
                </div> -->
              </div>
            </div>
            <!-- TEMP -->
          </div>
        </div>
        <div
          v-if="getBookshelfCurrentBook.relatedBooks"
          class="related_wrap pb"
        >
          <div class="inner">
            <router-link
              :to="{ name: 'books_category', params: { category: 'related' } }"
            >
              <h2>
                <span class="sec_title min"
                  ><span>{{
                    $t('views.library.librarybookdetail.2928')
                  }}</span></span
                >
              </h2>
            </router-link>
            <div class="eplist item_columns_6">
              <!-- 768px 사이즈 이하(모바일) 에서는 size_up 클래스 추가되며, 출판사 저자 정보 제시 - EAW-1-1-0_store.html 파일의 연관 도서와 동일한 형태로 변경 -->
              <ul class="item_list">
                <li
                  v-for="(related, idx) in (getBookshelfCurrentBook.relatedBooks.slice(0, 12))"
                  :key="idx"
                >
                  <div class="cover_wrap">
                    <router-link
                      :to="{
                        name: 'book_detail',
                        params: { id: related.bookCd }
                      }"
                      class="thum_wrap"
                    >
                      <img :src="related.thumbUrl" :alt="related.bookNm" />
                    </router-link>
                  </div>
                  <div class="info_wrap">
                    <h3 class="meta_title">{{ related.bookNm }}</h3>
                    <p class="row">
                      <span class="meta_author">{{ related.author }}</span
                      ><span class="gap">/</span
                      ><span class="meta_publisher">{{
                        related.publisher
                      }}</span>
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- 연관 도서 END -->
      </div>
      <!-- 도서 기본 정보 END-->

      <!-- 연관 도서 START -->
    </div>

    <!-- POD INFO MODAL -->
    <transition v-on-clickaway="togglePodModal" name="modal-fade">
      <Modal v-if="showPodModal" @close="togglePodModal">
        <div class="ly_pop_wrap">
          <div class="ly_pop_content ly_pop_msg ly_txt">
            <div class="ly_pop_head">
              <button class="btn_ly_close svg_close" @click="togglePodModal">
                <span>{{ $t('library.deletemodal.close') }}</span>
              </button>
            </div>
            <div class="ly_inner">
              <strong>{{ $t('views.library.librarybookdetail.pod4') }}</strong>
              <p>{{ $t('views.library.librarybookdetail.printOnDemand') }}</p>
              <div class="btnWrap">
                <button class="box_btn w-full" @click="toggleErrorModal">
                  <span class="an_t">{{
                    $t('library.deletemodal.close')
                  }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </transition>

    <!-- ERROR MODAL -->
    <transition v-on-clickaway="toggleErrorModal" name="modal-fade">
      <Modal v-if="showErrorModal" @close="toggleErrorModal">
        <div class="ly_pop_wrap">
          <div class="ly_pop_content ly_pop_msg ly_txt">
            <div class="ly_pop_head">
              <a class="btn_ly_close svg_close" @click="toggleErrorModal"
                ><span>{{ $t('library.deletemodal.close') }}</span></a
              >
            </div>
            <div class="ly_inner">
              <p>
                {{ errorMessage }}
              </p>
              <div class="btnWrap">
                <button class="box_btn w-full" @click="toggleErrorModal">
                  <span class="an_t">{{
                    $t('library.deletemodal.close')
                  }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </transition>
  </div>
</template>
<script>
import Sidebar from '@/components/library/Sidebar.vue'
// import StarRating from 'vue-star-rating'

import { mapGetters } from 'vuex'

import {
  BOOKSHELF_SET_CURRENT,
  BOOKSHELF_BOOK_GET_LIST,
  BOOKSHELF_BOOK_GET,
  BOOKSHELF_GET_LIST,
  UI_SHOW_SIDEBAR,
  SUPPLEMENT_STATUS,
  SUPPLEMENT_FILES,
  SUPPLEMENT_FILE_URL
} from '@/store/types'
import store from '@/store'
import Subbar from '@/components/library/Subbar.vue'
export default {
  components: {
    // StarRating,
    Sidebar,
    Subbar
  },
  data() {
    return {
      isListMenuOpen: false,
      // For star-rating package
      starSize: 18,
      increment: 0.5,
      showRating: false,
      readOnly: true,
      showPodModal: false,
      showErrorModal: false,
      errorMessage: '',
      todayDate: '',
      showSuppleList: false,
      responseData: null,
      isWebView: false
    }
  },
  computed: {
    ...mapGetters([
      'getBookshelves',
      'getCurrentBookshelf',
      'getBookshelfCurrentBook',
      'isBookshelfBookLoading',
      'isSidebarOpen',
      'getSupplementExists',
      'getSupplementFileNames'
    ]),
    isEndView() {
      if (!this.todayDate || !this.getBookshelfCurrentBook) return false

      if (this.getBookshelfCurrentBook.ebookOrders.isPeriodic) {
        let x = Number(this.todayDate.replaceAll('-', ''))
        let y = Number(
          this.getBookshelfCurrentBook.ebookOrders.rightsTo.replaceAll('-', '')
        )
        if (x > y) return true
      }
      if (!this.getBookshelfCurrentBook.ebookOrders.isViewable) return true
      return false
    },
    isDisableWebViewer() {
      if (
        this.getBookshelfCurrentBook.ebookOrders.purchaseTp === 'PRS' ||
        this.getBookshelfCurrentBook.ebookOrders.purchaseTp === 'CPN'
      ) {
        if (
          this.getBookshelfCurrentBook.couponStatusTp == 7 ||
          this.getBookshelfCurrentBook.couponStatusTp == 8
        ) {
          return this.getBookshelfCurrentBook.couponStatus
          // return false
        }
      }
      return false
    },
    purchaseLabel() {
      if (!this.getBookshelfCurrentBook?.ebookOrders) return
      let x = false
      switch (this.getBookshelfCurrentBook.ebookOrders.purchaseTp) {
        case 'PRS':
          x = '증정본'
          break
        case 'RNT':
          x = '대여'
          break
        case 'INT':
          x = '소장'
          break
        case 'GFT':
          x = '선물'
          break
        case 'CPN':
          x = '쿠폰'
          break
        case 'PFF':
          x = '무료'
          break
        default:
          x = false
          break
      }
      return x
    },
    getRightDays() {
      let left = this.getBookshelfCurrentBook.ebookOrders.rightsDays
      if (left === null) return '소장'
      else if (left > 0) return `${left.toString().padStart(3, '0')}일 남음`
      else return '대여기간 만료'
    },
    processedSource() {
      return this.responseData?.files?.map((item) => {
        const type = this.getFileType(item.fileType) // 확장자 그대로 전달
        return {
          ...item,
          type,
          typeText: this.getTypeText(type),
          icon: this.getTypeIcon(type)
        }
      })
    }
  },
  mounted() {
    // document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    // document.removeEventListener('click', this.handleClickOutside)
  },
  async beforeRouteEnter(to, from, next) {
    if (!store.getters.getBookshelves.length) {
      await store.dispatch(BOOKSHELF_GET_LIST)
    } else {
      next()
      return
    }
    const defaultBookshelf = store.getters.getBookshelves.find(
      (bs) => bs.isDefault
    )

    if (defaultBookshelf) {
      next({ name: 'library', params: { id: defaultBookshelf.id } })
      return
    }
  },
  async beforeMount() {
    let today = new Date()

    let year = today.getFullYear()
    let month = ('0' + (today.getMonth() + 1)).slice(-2)
    let day = ('0' + today.getDate()).slice(-2)

    let dateString = year + '-' + month + '-' + day

    this.todayDate = dateString
    const { id, orderId } = this.$route.params

    if (!this.getCurrentBookshelf) {
      this.$router.push({ name: 'library_book_detail', params: { id } })
    }

    this.$store.dispatch(BOOKSHELF_BOOK_GET, { id, orderId })
    await this.$store.dispatch(SUPPLEMENT_STATUS, id)
    this.responseData = await this.$store.dispatch(SUPPLEMENT_FILES, id)
  },
  methods: {
    goToCart() {
      const { id } = this.$route.params
      this.$router.push({
        name: 'book_detail',
        params: { id }
      })
    },
    toggleErrorModal(errorMessage) {
      if (errorMessage) {
        this.errorMessage = errorMessage
      }
      this.showErrorModal = !this.showErrorModal
    },
    togglePodModal() {
      this.showPodModal = !this.showPodModal
    },
    navigateBookshelf(id) {
      this.$store.commit(BOOKSHELF_SET_CURRENT, id)
      this.$store.dispatch(BOOKSHELF_BOOK_GET_LIST, { id })
      this.$router.push({ name: 'library', params: { id } })
      this.closeListMenu()
    },
    openSidebar() {
      this.$store.commit(UI_SHOW_SIDEBAR)
    },
    toggleListMenu() {
      this.isListMenuOpen = !this.isListMenuOpen
    },
    closeListMenu() {
      this.isListMenuOpen = false
    },
    showInViewer() {
      if (this.isDisableWebViewer) {
        this.toggleErrorModal(this.isDisableWebViewer)
        return
      }
      let chkAppUser = navigator.userAgent.toLowerCase()
      const isPreferredBrowser =
        chkAppUser.indexOf('chrome') > -1 ||
        chkAppUser.indexOf('safari') > -1 ||
        chkAppUser.indexOf('samsungbrowser') > -1

      const isKakaoTalk = chkAppUser.indexOf('kakaotalk') > -1

      // 권장 브라우저가 아니거나 카카오톡인 경우 경고 표시
      if (!isPreferredBrowser || isKakaoTalk) {
        this.isWebView = true
        alert(
          '현재 사용중인 브라우저에서는 도서 열람을 하실 경우 화면오류 또는 성능저하가 발생할 수 있습니다. 원활한 이용을 위해 Chrome, Safari, 또는 삼성 브라우저를 사용해주시기 바랍니다.'
        )
      }
      window.open(
        this.getBookshelfCurrentBook.webViewerUrl || '',
        '_blank'
        // 'toolbar=0,location=0,menubar=0'
      )
    },
    handleClickOutside(event) {
      // supplementWrap 영역 밖을 클릭했는지 확인
      if (
        // this.showSuppleList &&
        !this.$refs.supplementWrap.contains(event.target)
      ) {
        this.showSuppleList = false
      }
    },
    getFileType(extension) {
      const fileTypes = {
        image: ['png', 'jpg', 'svg', 'jpeg', 'gif', 'webp'],
        play: ['mp4', 'mov', 'wmv', 'avi', 'mkv', 'mp3', 'wav', 'm4a', 'flac'],
        archive: ['zip', 'egg', '7z'],
        excel: ['xls', 'xlsx'],
        powerpoint: ['ppt', 'pptx'],
        hangul: ['hwp'],
        word: ['doc', 'docx'],
        pdf: ['pdf']
      }
      // 확장자에 따른 파일 타입 찾기
      for (const [type, extensions] of Object.entries(fileTypes)) {
        if (extensions.includes(extension)) {
          return type
        }
      }
      // 매칭되는 타입이 없을 경우
      return 'etc'
    },
    getTypeText(type) {
      const typeTexts = {
        image: '이미지 파일',
        play: '동영상음성 파일',
        archive: '압축 파일',
        excel: '엑셀 파일',
        powerpoint: '파워포인트 파일',
        hangul: '한글 파일',
        word: '워드 파일',
        pdf: 'PDF 파일',
        etc: '기타 파일'
      }

      return typeTexts[type] || '기타 파일'
    },
    getTypeIcon(type) {
      const iconMap = {
        'image': require('@/assets/images/supple/image.png'),
        'play': require('@/assets/images/supple/play.png'),
        'archive': require('@/assets/images/supple/zip.png'),
        'excel': require('@/assets/images/supple/excel.png'),
        'powerpoint': require('@/assets/images/supple/powerpoint.png'),
        'hangul': require('@/assets/images/supple/hangul.png'),
        'word': require('@/assets/images/supple/word.png'),
        'pdf': require('@/assets/images/supple/pdf.png')
      }
      return iconMap[type] || require('@/assets/images/supple/etc.png')
    },
    toNumInUnits(bytes) {
      let u = 0
      for (; bytes > 1024 * 1024; bytes >>= 10) {
        u++
      }
      if (bytes > 1024) u++

      return (
        (bytes / 1024).toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
        `${' KMGTPE'[u]}B`
      )
    },
    async downloadTry(supplement) {
      const fileId = supplement.fileId

      try {
        // Vuex 액션을 통해 서버로부터 다운로드 링크를 요청
        const response = await this.$store.dispatch(SUPPLEMENT_FILE_URL, fileId)
        const downloadUrl = response.downloadUrl // 서버가 downloadUrl을 반환한다고 가정

        if (!downloadUrl) {
          throw new Error('다운로드 URL을 찾을 수 없습니다.')
        }

        // Blob URL을 생성하여 다운로드 트리거 (가짜 a 태그 사용)
        this.triggerDownload(downloadUrl)
      } catch (error) {
        alert('파일 다운로드에 실패했습니다. 다시 시도해주세요.')
      }
    },
    triggerDownload(url) {
      const link = document.createElement('a')
      link.href = url
      link.download = '' // 파일 이름은 서버에서 지정된 것으로 자동 설정됨
      link.style.display = 'none' // 화면에 표시되지 않도록 설정
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link) // 태그 제거
    }
  }
}
</script>
<style src="@/assets/css/apply/page_book_shared.css" scoped></style>
<style lang="scss" scoped>
/* 연관 도서 */
.eplist.item_columns_6 .meta_author {
  max-width: calc(50% - 9px);
}
.item_list {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  place-content: center;
  place-items: center;
  li {
    width: 120px;
  }
}
.item_list .cover_wrap {
  position: relative;
  width: 100%;
  height: 170px;
  margin-bottom: 10px;
}
.meta_title {
  text-align: left;
  margin-bottom: 5px;
}
.eplist .info_wrap a + p {
  line-height: 1.286em;
}
.meta_detail {
  max-width: 480px;
  padding-top: 10px;
  .flex {
    justify-content: flex-end;
    align-items: center;
    height: 100%;
  }
}
.section.fill.pb .inner {
  padding-bottom: 50px;
}
.buy_btn {
  background-color: #042479 !important;
  span {
    color: white !important;
    margin: 0 !important;
  }
}
.detail_book {
  padding: 48px 0px;
  a.an_a {
    background-color: #042479;
    width: 240px;
    border: none;
    border-radius: 0;
    .an_t {
      color: #fff;
      margin-top: 0;
    }
  }
  .iconbox {
    display: flex;
    align-items: center;
    .meta_editer {
      float: none;
      padding: 3px 0;
      border-radius: 5px;
      font-family: 'pretendard-medium';
      font-size: 12px;
      color: #fff;
      &.ebook {
        background-color: #39a5c1;
      }
      &.onlyEbook {
        width: 92px;
        background-color: #008df3;
      }
      &.supplement {
        width: 60px;
        background-color: #135f88;
      }
    }
  }
}
.relative {
  position: relative;
  .related_wrap {
    position: relative;
    padding: 32px 0px 48px;
    width: 100%;
    height: auto;
    background-color: #ffffff;
  }
}
.info_wrap {
  .row {
    gap: 4px;
    width: 100%;
    p {
      color: #686868;
      font-size: 14px;
      font-family: 'pretendard-medium';
    }
    p > .sub {
      color: #39a5c1;
      font-size: 14px;
    }
  }
}
.supplement_wrap {
  position: relative;
  max-width: 240px;
  margin: 5px auto 0;
  user-select: none;
  .supplement_download {
    position: relative;
    display: flex;
    justify-content: center;
    padding: 10px 0px;
    background: #39a5c1;
    letter-spacing: 0.2px;
    font-size: 15px;
    color: #fff;
    cursor: pointer;
    img {
      position: absolute;
      left: 25px;
      top: 12px;
      width: 15px;
      height: 15px;
      &.is-open {
        transform: rotate(-180deg);
      }
    }
  }
  .supplement_list {
    max-height: 150px;
    background-color: #fff;
    border-right: 1px solid #b4ecf9;
    border-bottom: 1px solid #b4ecf9;
    border-left: 1px solid #b4ecf9;
    overflow-y: auto;
    .download_btn {
      display: flex;
      align-items: center;
      gap: 5px;
      padding: 7px 10px 7px 10px;
      border: none;
      cursor: pointer;
      &:hover {
        background-color: #e1f2ff;
      }
      img {
        width: 13px;
        height: 13px;
      }
      span {
        &.supple_name {
          overflow: hidden;
          width: 130px;
          height: 16px;
          white-space: nowrap;
          text-overflow: ellipsis;
          text-align: left;
          font-family: 'pretendard-medium';
          font-size: 13px;
          color: #707070;
        }
        &.supple_size {
          height: 16px;
          font-family: 'pretendard-light';
          font-size: 12px;
          color: rgb(153, 153, 153);
        }
      }
    }
  }
}
.detail_book .info_wrap .iconbox {
  display: flex;
  align-items: center;
}
// 2022. 05. 13 추가 개발
.free_label {
  background: #3a89ff;
  height: 21px;
  position: absolute;
  box-shadow: 0px 2px 2px rgb(0 0 0 / 30%);
  left: 10px;
  top: 7px;
  padding: 0 10px;
  border-radius: 6px;
  text-align: center;
  line-height: 21px;
  color: #ffffff;
  font-weight: 500;
  font-size: 11px;
  white-space: nowrap;
}
.free_label_2 {
  background: #ff6a85;
}
.free_label_3 {
  background: #aa6aff;
  padding: 0 4px;
}
// 추가
.aside_snb {
  width: calc(50vw - (var(--scrollbar-width) / 2) - 560px);
  min-width: 230px;
  max-width: 400px;
}
.sub_bar_custom,
.section {
  max-width: 1120px;
}
.section {
  background: #f0f5fa;
  width: 100%;
}
@media (min-width: 1024px) {
  #container.grid-container {
    grid-template-columns:
      minmax(
        // eslint-disable-next-line prettier/prettier
          230px,
        calc(50vw - (var(--scrollbar-width) / 2) - 560px)
      )
      1fr;
    column-gap: 0;
    min-height: 1050px;
    .section {
      justify-self: start;
      margin: 0;
    }
  }
  .detail_book {
    height: 550px;
    padding: 35px 0px;
  }
  .sub_bar_custom {
    margin-left: 60px;
  }
  .sub_bar_custom,
  .section {
    max-width: 1060px;
    .inner {
      padding-left: 60px;
      margin: 0;
    }
  }
  .section {
    .related_wrap.pb {
      &::before {
        content: '';
        position: absolute;
        left: -20vw;
        top: 0;
        width: 120vw;
        height: 100%;
        background-color: #ffffff;
      }
    }
  }
}
@media (max-width: 980px) {
  .detail_book {
    padding: 0;
  }

  .detail_book {
    a.an_a {
      width: 90%;
    }
  }
  .relative {
    .related_wrap {
      padding: 0;
      .inner {
        padding: 24px 16px;
      }
    }
  }
  .info_wrap {
    .row {
      width: 100%;
    }
  }
  .supplement_wrap {
    width: 90%;
    .supplement_download {
      justify-content: start;
      gap: 30px;
      padding: 10px 0 10px 20px;
      font-size: 15px;
      img {
        position: static;
        width: 16px;
        height: 16px;
      }
    }
    .supplement_list {
      a {
        padding: 7px 10px 7px 10px;
      }
    }
  }
}
@media (max-width: 768px) {
  .detail_book a.an_a {
    width: 100%;
  }
  .detail_book .meta_detail dt {
    width: 120px;
    padding-left: 18px;
  }
  .detail_book .meta_detail dd {
    width: calc(100% - 120px);
    padding-right: 18px;
  }
  .supplement_wrap {
    width: 100%;
    .supplement_download {
      gap: 12px;
      padding: 10px 0 10px 10px;
    }
    .supplement_list {
      a {
        padding: 7px 5px 7px 5px;
        img {
          width: 13px;
          height: 13px;
        }
        span {
          font-size: 12px;
        }
      }
    }
  }
}
@media (max-width: 600px) {
  .item_list {
    grid-template-columns: repeat(3, 1fr);
  }
  .inner {
    margin-bottom: 20px;
  }
}
@media (max-width: 445px) {
  .flex {
    font-size: 11px;
  }
}
</style>
